// Create: /pages/AdminDashboardPage.jsx
import React from 'react';
import AdminDashboard from '../components/Admin/AdminDashboardNew';

const AdminDashboardPage = () => {
  return <AdminDashboard />;
};

export default AdminDashboardPage;